import "reflect-metadata";
import {
  IsUUID,
  IsInt,
  IsPositive,
  IsOptional,
  IsBoolean,
  IsEnum,
  IsString,
  IsDate
} from "class-validator";
import { Type } from "class-transformer";

import DocumentVersion from "./unitable/document/version";
import RelationVersion from "../relation/version";
import UnitUnit from "./unit";
import TestVersion from "./unitable/test/version";
import PracticalVersion from "./unitable/practical/version";
import EventVersion from "@/models/unit/unitable/event/version";

export enum EUnitableType {
  "Document::Version" = "Document::Version",
  "Test::Version" = "Test::Version",
  "Practical::Version" = "Practical::Version",
  "Event::Version" = "Event::Version",
  "Program::Inspector" = "Program::Inspector"
}

export default class UnitVersion {
  @IsUUID("4")
  public readonly id!: string;

  @IsOptional()
  @IsString()
  public title?: string;

  @IsBoolean()
  public is_draft: boolean = true;

  @IsInt()
  @IsPositive()
  public version: number = 0;

  @IsOptional()
  @IsDate()
  public created_at?: Date;

  @IsOptional()
  @IsDate()
  public updated_at?: Date;

  @IsOptional()
  @IsString()
  public author_name?: string;

  @IsOptional()
  @IsEnum(EUnitableType)
  public unitable_type?: EUnitableType;

  @Type(() => UnitUnit)
  public unit?: UnitUnit;

  @Type(() => Object, {
    discriminator: {
      property: "unitable_type",
      subTypes: [
        { value: DocumentVersion, name: "Document::Version" },
        { value: TestVersion, name: "Test::Version" },
        { value: PracticalVersion, name: "Practical::Version" },
        { value: EventVersion, name: "Event::Version" }
      ]
    }
  })
  public unitable?:
    | DocumentVersion
    | TestVersion
    | PracticalVersion
    | EventVersion;

  @Type(() => RelationVersion)
  public relation_version?: RelationVersion;

  constructor(data?: any) {
    if (data) {
      if (typeof data.id === "string") {
        this.id = data.id;
      }

      if (typeof data.title === "string") {
        this.title = data.title;
      }

      if (typeof data.is_draft === "boolean") {
        this.is_draft = data.is_draft;
      }

      if (typeof data.version === "number") {
        this.version = data.version;
      }

      if (data.unit && data.unit instanceof UnitUnit) {
        this.unit = data.unit;
      } else {
        this.unit = new UnitUnit();
      }

      if (
        data.relation_version &&
        data.relation_version instanceof RelationVersion
      ) {
        this.relation_version = data.relation_version;
      }

      if (data.unitable) {
        this.unitable = data.unitable;
      }

      if (data.unitable_type) {
        this.unitable_type = data.unitable_type;
      }
    }
  }
}
